import React, { useRef, useState } from "react";
import './Gap.css';
import { motion } from "framer-motion";
import Card from "../Card/Card";
import { Copy } from "lucide-react";

const Gap = () => {
  const gutterBox = useRef(null);
  const [twin, settwin] = useState(false);
  const copySnippet = () => {
    if (gutterBox.current) {
      const range = document.createRange();
      range.selectNode(gutterBox.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();

      settwin(true);
      setTimeout(() => settwin(false), 1000);
    }
  };
  return (
    <motion.div initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -10, opacity: 0 }} transition={{ duration: 0.2 }}>

      <div className="Grid ">
        <div className="carve-fat-body text-center">
          <div className="carve-line g-sm">
            <div className="box-4">
              <div className="p-3"></div>
            </div>
            <div className="box-4">
              <div className="p-3"></div>
            </div>
            <div className="box-4">
              <div className="p-3"></div>
            </div>
            <div className="box-4">
              <div className="p-3"></div>
            </div>
          </div>
        </div>
        <div className={`center-container ${twin ? "scanning" : ""}`}>

          <div className="snippet" ref={gutterBox}>
            <pre>
              <code className="ColorSnippet">
                <span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">Grid</span><span className="cln">"</span><span className="cn">&gt;</span><br />

                &nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">carve-fat-body text-center</span><span className="cln">"</span><span className="cn">&gt;</span><br />

                &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">carve-line g-sm</span><span className="cln">"</span><span className="cn">&gt;</span><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">box-4</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">p-3</span><span className="cln">"</span><span className="cn">&gt;&lt;/div&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">box-4</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">p-3</span><span className="cln">"</span><span className="cn">&gt;&lt;/div&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">box-4</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">p-3</span><span className="cln">"</span><span className="cn">&gt;&lt;/div&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span><br />

                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">box-4</span><span className="cln">"</span><span className="cn">&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;div</span><span className="cln"> class="</span><span className="cn">p-3</span><span className="cln">"</span><span className="cn">&gt;&lt;/div&gt;</span><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span><br />

                &nbsp;&nbsp;&nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span><br />
                &nbsp;&nbsp;<span className="cn">&lt;/div&gt;</span><br />
                <span className="cn">&lt;/div&gt;</span><br />
              </code>
            </pre>

          </div>
          <button aria-label="Copy Button" onClick={copySnippet}>
            <Copy/>
          </button>
        </div>
      </div>
    </motion.div>
  );
}

const CardGap = () => {
  return (
    <Card
      CardTitle={<h2 className="heading-xlarge"> <u>
        <b>gutter</b>
      </u></h2>}
      CardBody={<Gap />}
    />
  );
}
export default CardGap;
